import { connect } from 'react-redux';
import { getPartnerDetailsData } from '@yme/api';
import { setPageProperties as setPagePropertiesAction } from '@yme/common/redux/common/action';
import { PARTNER_BY_PATH_ENDPOINT } from '@yme/components/Destinations/PartnerDetailsPage/components/PartnerDetailsCard/constants';
import { setInitialPartnerDetailsData as setInitialPartnerDetailsDataAction, setPartnerDetailsData as setPartnerDetailsDataAction, } from '@yme/components/Destinations/PartnerDetailsPage/redux/actions';
import BaseDetailsPage from '@yme/components/Destinations/components/BaseDetailsPage';
class PartnerDetailsPage extends BaseDetailsPage {
    fetchDetailsData() {
        getPartnerDetailsData(`${PARTNER_BY_PATH_ENDPOINT}${this.props.destinationEntityId}`).then((data) => {
            this.props.setPartnerDetailsData(data);
        });
    }
    setInitialData() {
        this.props.setInitialPartnerDetailsData();
    }
}
export default connect(null, {
    setPageProperties: setPagePropertiesAction,
    setPartnerDetailsData: setPartnerDetailsDataAction,
    setInitialPartnerDetailsData: setInitialPartnerDetailsDataAction,
})(PartnerDetailsPage);
